/* eslint-disable no-unused-vars */
import React, { useState } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@windmill/react-ui";

function Modals({
  state,
  onClick,
  actionButtonMobile,
  actionButtonDesktop,
  title,
  children,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function openModal() {
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <>
      {/* <div>
        <Button onClick={openModal}>Open modal</Button>
      </div> */}

      <Modal isOpen={state} onClose={onClick}>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          {/* I don't like this approach. Consider passing a prop to ModalFooter
           * that if present, would duplicate the buttons in a way similar to this.
           * Or, maybe find some way to pass something like size="large md:regular"
           * to Button
           */}
          <div className="hidden sm:block">
            <Button layout="outline" onClick={onClick}>
              Cancel
            </Button>
          </div>
          {actionButtonDesktop}
          <div className="block w-full sm:hidden">
            <Button block size="large" layout="outline" onClick={onClick}>
              Cancel
            </Button>
          </div>
          {actionButtonMobile}
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Modals;
